import * as React from 'react';

export interface IT1IconProps {
  color?: string;
  size?: string | number;
  title?: string;
}

export const T1Icon = React.forwardRef<SVGSVGElement, IT1IconProps>(
  ({ color = 'currentColor', size = '1em', title = null, ...rest }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        width={size}
        height={size}
        fill={color}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <g xmlns="http://www.w3.org/2000/svg" transform="matrix(1.0404,0,0,1.0404,-98.016,-47.497)">
          <g fontFamily="sans-serif" fontSize="10.583px" wordSpacing="0px" aria-label="T 1">
            <g
              transform="matrix(.92985 0 0 .86537 6.8704 6.826)"
              fontFamily="sans-serif"
              fontSize="10.583px"
              aria-label="T1"
            >
              <g
                transform="matrix(3.0828,0,0,3.3126,-203.5,-95.579)"
                fontFamily="sans-serif"
                fontSize="8.652px"
                strokeWidth=".0072031"
                aria-label="T1"
              >
                <g aria-label="T1">
                  <path d="m96.966 43.283q0-0.19967 0.19967-0.19967h1.9967q0.19967 0 0.19967 0.19967t-0.19967 0.19967h-0.79867v3.3943q0 0.19967-0.19967 0.19967t-0.19967-0.19967v-3.3943h-0.79867q-0.19967 0-0.19967-0.19967z" />
                  <path
                    d="m100.5 43.765-0.54077 0.46505q-0.0676 0.05813-0.16365 0.05813-0.23482 0-0.23482-0.20193 0-0.08261 0.06762-0.14074l0.91789-0.78936q0.0926-0.07955 0.18857-0.07955 0.23481 0 0.23481 0.20193v3.6347q0 0.20193-0.23481 0.20193-0.23482 0-0.23482-0.20193z"
                    strokeWidth=".0078555"
                  />
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    );
  },
);
